var map = {
	"./1.jpg": 454,
	"./2.jpg": 207,
	"./3.jpg": 790,
	"./4.jpg": 596,
	"./5.jpg": 24,
	"./6.jpg": 752,
	"./7.jpg": 126,
	"./8.jpg": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 797;